import { Component, ViewChild, ElementRef, inject } from '@angular/core';
import {GameService} from "../../services/game.service";
import {Hash} from "../../model/hash";
import {DEFAULT_KICKOFF_YARD_LINE} from "../../helpers/distance";
import {ODK} from "../../model/odk";
import {DialogEndQuarterComponent} from "../dialog-end-quarter/dialog-end-quarter.component";
import {GameStatus} from "../../model/gameStatus";
import {MatDialog} from "@angular/material/dialog";
import {Router} from "@angular/router";
import {
  WheelSelectorSetValueDialogComponent
} from "../wheel-selector-set-value-dialog/wheel-selector-set-value-dialog.component";
import { NgOptimizedImage } from '@angular/common';
import { CurrentActionComponent } from '../current-action/current-action.component';

@Component({
    selector: 'app-score-board',
    templateUrl: './score-board.component.html',
    styleUrls: ['./score-board.component.scss'],
    imports: [NgOptimizedImage, CurrentActionComponent]
})
export class ScoreBoardComponent {
  game = inject(GameService);
  dialog = inject(MatDialog);
  router = inject(Router);


  lastQuarter = false;
  protected readonly Hash = Hash;

  getQuarter() {
      return this.game.getFirstPendingGamePlay().qtr
  }

  @ViewChild("homeScoreInput")
  set homeScoreInput(element: ElementRef<HTMLInputElement>) {
    if(element) {
      element.nativeElement.focus()
    }
  }

  @ViewChild("awayScoreInput")
  set awayScoreInput(element: ElementRef<HTMLInputElement>) {
    if(element) {
      element.nativeElement.focus()
    }
  }

  toogleHomeScoreInput() {
    this.openDialog(this.updateHomeScore)
  }

  toogleAwayScoreInput() {
    this.openDialog(this.updateAwayScore)
  }

  openDialog(updateScoreCallback: any) {
    // FIXME impossible de saisir un nombre > 99 pour l'instant
    const dialogRef = this.dialog.open(WheelSelectorSetValueDialogComponent, {
      data: {
        gain: true,
        homeHasPossession: true,
        displayPlusMinusButton: false
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.value) {
        updateScoreCallback.call(this, result.value)
      }
    });
  }

  updateHomeScore(newHomeScore: number) {
    if (this.game.getGame().homeScore !== newHomeScore && newHomeScore > 0) {
      this.game.setScore({ home: newHomeScore})
      this.game.updateScore(newHomeScore, this.game.getGame().awayScore)
    }
  }

  updateAwayScore(newAwayScore: number) {
    if (this.game.getGame().awayScore !== newAwayScore && newAwayScore > 0) {
      this.game.setScore({ away: newAwayScore})
      this.game.updateScore(this.game.getGame().homeScore, newAwayScore)
    }
  }

  changeQuarter() {
    const quarter = this.game.getFirstPendingGamePlay().qtr

    switch (quarter) {
      case 1:
        this.endQuarter(quarter, () => this.game.getFirstPendingGamePlay().qtr = 2)
        break;
      case 2:
        this.endQuarter(quarter, () => {
          this.game.getFirstPendingGamePlay().yardLine = DEFAULT_KICKOFF_YARD_LINE
          this.game.getFirstPendingGamePlay().qtr = 3;
          this.game.getFirstPendingGamePlay().odk = ODK.Kick
          this.router.navigate(['/game-play/kickoff-selection']);
        })
        break;
      case 3:
        this.endQuarter(quarter, () => {
          this.game.getFirstPendingGamePlay().qtr = 4;
          this.lastQuarter = true;
        })
        break;
      case 4:
      case 5:
        this.endThisGame(quarter);
        break;
    }
  }

  private endQuarter(qtr: number, callback: () => void) {
    const dialogRef = this.dialog.open(DialogEndQuarterComponent, { data: { quarter: qtr }});
    dialogRef.afterClosed().subscribe(result => {
      if (result?.action === "end") {
        callback()
      }
    })
  }

  private endThisGame(qtr: number) {
    const dialogRef = this.dialog.open(DialogEndQuarterComponent, { data: { quarter: qtr }});
    dialogRef.afterClosed().subscribe(result => {
      if (result?.action === "end") {
        this.game.changeGameStatus(GameStatus.InReview);
      } else if (result?.action === "overtime") {
        this.game.getFirstPendingGamePlay().qtr = 5;
        this.router.navigate(['/select-play-options-overtime']);
      }
    })
  }

  protected readonly GameStatus = GameStatus;
}
